module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_mentorships_text_sm-13c14e630ee6c0b83ca1de994a16f6d1.svg";